import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobById } from "../../Redux/ActionCreators/jobsAction";


const JobDetails = () => {
  const [isEditable, setIsEditable] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("error");
  const [snackMessage, setSnackMessage] = useState("");
  const [showVoicePopup, setShowVoicePopup] = useState(false);
  const [linkValue, setLinkValue] = useState("");
  const [loadingJob, setLoadingJob] = useState(true);
  const [descPopup, setDescPopup] = useState(false);

  const { jobId } = useParams();
  const navigate = useNavigate();

  const job = useSelector((state) => state.jobs.latestJob);
  const dispatch = useDispatch();


  useEffect(() => {
    const fetchJobData = async () => {
      if (jobId) {
        setLoadingJob(true);
        await dispatch(fetchJobById(jobId));
        setLoadingJob(false);
      }
    };
    fetchJobData();
  }, [dispatch, jobId]);

  useEffect(() => {
    if (job?.id) {
      const baseUrl = window.location.origin;
      const jobLink = `${baseUrl}/jobs/${job.id}/apply`;
      setLinkValue(jobLink);
    }
  }, [job]);

  const handleCopyLink = () => {
    if (linkValue) {
      navigator.clipboard.writeText(linkValue);
      showSnack("Link copied to clipboard!", "success");
    }
  };

  const handleCopyDescription = () => {
    if (job?.description) {
      navigator.clipboard.writeText(job.description);
      showSnack("Description copied to clipboard!", "success");
    }
  };

  const handleToggleEdit = () => {
    setIsEditable(!isEditable);
    if (!isEditable) {
      setLinkValue(job?.url);
    }
  };

  const handleShare = (platform) => {
    let shareUrl;
    if (platform === "facebook") {
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        linkValue
      )}`;
    } else if (platform === "linkedin") {
      shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        linkValue
      )}`;
    }
    window.open(shareUrl, "_blank");
  };

  const snackClosed = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackOpen(false);
  };

  const showSnack = (message, severity = "error") => {
    setSnackMessage(message);
    setSnackSeverity(severity);
    setSnackOpen(true);
  };

  if (loadingJob) {
    return (
      <div className="job-summary">
        <div className="loading-overlay">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading job summary...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!jobId) {
    return <div className="job-summary">Job ID is missing.</div>;
  }

  return (
    <div className="job-summary">
      {/* Job Title Section */}
      <div className="job-summary-title">
        {/* Link Input Field with Buttons */}
        <h6 className="job-summary-link-title">URL</h6>
          <div className="job-summary-link">
            <input
              type="text"
              value={linkValue}
              onChange={(e) => setLinkValue(e.target.value)}
              readOnly={!isEditable}
              style={isEditable ? { backgroundColor: "white" } : null}
            />
            <button
              className="job-summary-inputbtn btn1"
              onClick={handleToggleEdit}
              style={isEditable ? { right: "200px" } : null}
            >
            </button>
            <button
              className="job-summary-inputbtn btn2"
              onClick={handleCopyLink}
            >
              <img src="/images/copy-outline-icon.svg" alt="" />
            </button>

            {/* Share Buttons */}
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className="job-summary-share-icons"
                onClick={() => handleShare("facebook")}
              >
                <img src="/images/Facebook-icon.svg" alt="" width={24} height={24} />
              </button>
              <button
                className="job-summary-share-icons"
                onClick={() => handleShare("linkedin")}
              >
                <img src="/images/LinkedIn-icon.svg" alt="" width={32} height={32} />
              </button>
            </div>
          </div>
      </div>
      {/* Job Details */}
      <div className="job-candidte-details">
        <div className="job-details">
          <div className="job-details-item">
            <div className="job-details-basic">
              <div className="detail-item">
                <h6>Company name</h6>
                <p>{job?.company_name || "null"}</p>
              </div>
              <div className="detail-item">
                <h6>Employment type</h6>
                <p>{job?.job_type?.name || "null"}</p>
              </div>
              <div className="detail-item">
                <h6>Salary range</h6>
                <p>{job?.salary || "null"}</p>
              </div>
              <div className="detail-item">
                <h6>Location</h6>
                <p>
                  {job?.country?.name || null},&nbsp;{job?.city?.name || "null"}
                </p>
              </div>
              <div className="detail-item">
                <h6>Experience</h6>
                <p>{job?.experience_required || "null"}</p>
              </div>
              <div className="detail-item">
                <h6>Skills</h6>
                <div className="multiple-skills">
                  {job?.skills?.slice(0, 2).map((skills, index) => (
                    <p className="candidate-skills" key={index}>
                      {skills}
                    </p>
                  ))}
                    {job?.skills?.length > 2 && (
                      <div className="candidate-skills more-skills">
                        +{job.skills.length - 2} more
                        <div className="skills-popup">
                          {job.skills.slice(2).map((s, idx, arr) => (
                            <span key={idx}>
                              {s}
                              {idx < arr.length - 1 && ", "}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="detail-item">
              <div className="d-flex justify-content-between">
                <h6>Description</h6>
                <button className="job-description-inputbtn" onClick={handleCopyDescription}>
                  <img src="/images/copy-outline-icon.svg" alt="" />
                </button>
              </div>
              <p style={{lineHeight:'28px', whiteSpace: "pre-line" }}>
                {job?.description || "null"}
                </p>
            </div>
          </div>
        </div>
      </div>

      {showVoicePopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className="d-flex justify-content-between align-items-center">
              <h3>Set up voice interview</h3>
              <img
                src="/images/close.svg"
                alt=""
                onClick={() => setShowVoicePopup(false)}
              />
            </div>
            <div className="job-form">
              <div className="job-form-inputs d-flex">
                <div className="form-section">
                  <label>Select voice</label>
                  <input type="text" placeholder="input text" />
                </div>
                <div className="form-section">
                  <label>Call hours</label>
                  <input type="text" placeholder="input text" />
                </div>
              </div>
              <div className="job-form-inputs d-flex">
                <div className="form-section">
                  <label>Number of attempts (each candidate)</label>
                  <input type="number" placeholder="input text" />
                </div>
                <div className="form-section">
                  <label>Language</label>
                  <input type="text" placeholder="input text" />
                </div>
              </div>
              <button
                className="submit-btn"
                onClick={() => navigate(`/jobs/${jobId}/candidates`)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {descPopup && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: "600px", height: "auto" }}
          >
            <div className="modal-head">
              <h3>Job Details</h3>
              <img
                src="/images/close-icon.svg"
                alt=""
                onClick={() => setDescPopup(false)}
              />
            </div>
            <div
              className="modal-input d-flex flex-column align-items-start"
              style={{ height: "220px", width: "auto", padding: "0" }}
            >
              <textarea
                value={job?.description}
                placeholder="Enter description"
                style={{
                  height: "220px",
                  background: "transparent",
                  borderRadius: "8px",
                  border: "none",
                }}
              />
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setDescPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackOpen}
        autoHideDuration={3000}
        onClose={snackClosed}
      >
        <Alert
          onClose={snackClosed}
          severity={snackSeverity}
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default JobDetails;
